// extracted by mini-css-extract-plugin
module.exports = {"carousel":"b1ddd01198--carousel--FCofi","counter":"b1ddd01198--counter--FMi5H","single-photo":"b1ddd01198--single-photo--Kctus"};